module.exports = __webpack_public_path__ + "img/equipment-Cap-02.d0e265b6.png";